import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Row, Col, notification, Popover, Spin } from "antd";
import { getAPIUrl } from "../../configs/global_var";

import { history } from "../../history";
import { setToken } from "../../redux/actions/auth/loginActions";
import axiosGlobal from "../../axios-global";
// const axios = axiosGlobal();

import "../../assets/css/register.css";

class Index extends Component {
  state = {
    msg: null,
    samePass: null,
    education: [],
    zipcode: [],
    identity_number: null,
    identity_code: null,
    fullname: null,
    nickname: null,
    email: this.props.email,
    password: null,
    confirmPass: null,
    birth_place: null,
    birth_date: null,
    home_phone: null,
    mobile_phone: null,
    gender: null,
    educational_code: null,
    address: null,
    university: null,
    code: "all",
    province: null,
    city: null,
    id_pos: null,
    formInst: null,
    loading: true,
  };

  componentDidMount() {
    if (!this.props.isRegister) {
      history.push("home");
      window.location.reload();
    }
    this.getFormInst();
    this.getEducation();
    this.getCode();
  }

  componentDidUpdate() {
    window.onpopstate = () => {
      localStorage.clear();
    };
  }

  async getFormInst() {
    const resFormInst = await getAPIUrl();
    this.setState({ formInst: resFormInst[0].inst_form, loading: false });
  }

  getEducation() {
    axiosGlobal().then((axios) => {
      axios.post(`/reference/educational/stage`).then((resEdu) => {
        resEdu.data.data.map((v) => {
          v["value"] = v.educational_code;
          v["label"] = v.educational_name;
        });
        this.setState({ education: resEdu.data.data });
      });
    });
  }

  getCode = () => {
    axiosGlobal().then((axios) => {
      axios
        .post(`/reference/zipcode/${this.state.code}`)
        .then((res) => {
          res.data.data.map((v) => {
            v["value"] = v.id_pos;
            v["label"] = v.pos_name;
          });
          this.setState({ zipcode: res.data.data });
        })
        .catch(() => {});
    });
  };

  handlePassword = () => {
    if (this.state.password) {
      if (this.state.password.length < 8) {
        this.setState({ msg: "Password minimal 8 karakter" });
      } else {
        this.setState({ msg: "" });
      }
    } else {
      this.setState({ msg: "Password cannot be null" });
    }
  };

  validPassword = () => {
    if (this.state.password !== this.state.confirmPass) {
      this.setState({
        samePass: "Password with confirmation password must be the same",
      });
    } else {
      this.setState({ samePass: "" });
    }
  };

  handleInputChange = (newValue) => {
    if (newValue) {
      const inputValue = newValue.replace(/\W/g, "");
      this.setState({
        code: inputValue,
      });
      this.getCode();
    }
  };

  handleSelectChange = (e) => {
    if (e) {
      this.setState({
        province: e.provinsi,
        city: e.kota,
        code: e.kode_pos,
        id_pos: e.id_pos,
      });
    }
  };

  openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 3,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  content = (color, text) => {
    const content = <p style={{ color: `${color}` }}> {text} </p>;
    return content;
  };

  required() {
    if (
      this.state.identity_number &&
      this.state.identity_code &&
      this.state.fullname &&
      this.state.nickname &&
      this.state.password &&
      this.state.password.length >= 8 &&
      this.state.birth_place &&
      this.state.birth_date &&
      this.state.gender &&
      this.state.home_phone &&
      this.state.mobile_phone &&
      this.state.email &&
      this.state.address &&
      this.state.id_pos &&
      this.state.code !== "all" &&
      this.state.city &&
      this.state.province &&
      this.state.educational_code
    ) {
      return true;
    } else {
      return false;
    }
  }

  submit() {
    const {
      identity_number,
      identity_code,
      fullname,
      nickname,
      email,
      password,
      birth_place,
      birth_date,
      home_phone,
      mobile_phone,
      gender,
      educational_code,
      address,
      university,
      code,
      province,
      city,
      id_pos,
    } = this.state;

    const formInst = this.state.formInst?.field;
    const obj = {
      identity_number: !formInst ? identity_number : email,
      identity_code: !formInst ? identity_code : 1,
      fullname,
      nickname,
      password,
      birth_place,
      birth_date,
      gender_code: gender,
      home_phone,
      mobile_phone,
      email,
      address,
      university,
      id_pos: id_pos,
      zipcode: code,
      city,
      province,
      educational_code,
    };

    axiosGlobal().then((axios) => {
      axios
        .post(`/junior/register`, {
          data_personal: obj,
        })
        .then((res) => {
          if (res.status === 200) {
            this.openNotification("Berhasil mendaftar", true);
            setTimeout(() => {
              this.props.setToken(res.data.data.token);
              history.push("/ecommerce/home");
              window.location.reload();
            }, 1500);
          }
        })
        .catch(() => {
          this.openNotification("Gagal mendaftar", false);
        });
    });
  }

  render() {
    if (!this.props.isRegister) return null;

    if (this.state.loading) return <Spin />;
    const formInst = this.state.formInst?.field;

    return (
      <main>
        <>
          {!formInst && (
            <section>
              <Col
                md={{ span: 14, offset: 5 }}
                sm={{ span: 18, offset: 3 }}
                xs={{ span: 20, offset: 2 }}
                className="card-inner-register"
              >
                <Row>
                  {/* row1 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="number"
                        placeholder="No KTP, NIK, No Passport"
                        onChange={(event) =>
                          this.setState({ identity_number: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <select
                        className="effect-1"
                        style={{
                          padding: "0.5rem",
                          borderRadius: "8px",
                          backgroundColor: "#ffff",
                        }}
                        placeholder="identity_code"
                        onChange={(event) =>
                          this.setState({ identity_code: event.target.value })
                        }
                        required
                      >
                        <option value="" disabled selected>
                          Jenis Identitas
                        </option>
                        <option value={1}>KTP</option>
                      </select>
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row2 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="text"
                        placeholder="Fullname"
                        onChange={(event) =>
                          this.setState({ fullname: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="text"
                        placeholder="Nickname"
                        onChange={(event) =>
                          this.setState({ nickname: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row3 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <textarea
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        placeholder="Address"
                        onChange={(event) =>
                          this.setState({ address: event.target.value })
                        }
                        required
                      />
                      <span
                        className="focus-border"
                        style={{ bottom: "0.35rem" }}
                      />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <textarea
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        placeholder="Asal Sekolah/Universitas"
                        onChange={(event) =>
                          this.setState({ university: event.target.value })
                        }
                        required
                      />
                      <span
                        className="focus-border"
                        style={{ bottom: "0.35rem" }}
                      />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="email"
                        placeholder="Email"
                        value={this.state.email}
                        onChange={(event) =>
                          this.setState({ email: event.target.value })
                        }
                        readOnly
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row4 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto auto auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="password"
                        placeholder="Password"
                        onChange={(event) =>
                          this.setState({ password: event.target.value })
                        }
                        onBlur={this.handlePassword}
                        required
                      />
                      <text
                        style={{
                          color: "red",
                          padding: "0.5rem",
                          display: "block",
                        }}
                      >
                        {this.state.msg}
                      </text>
                      <span
                        className="focus-border"
                        style={{ top: "2.5rem" }}
                      />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto auto auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="password"
                        placeholder="Confirmation password"
                        onChange={(event) =>
                          this.setState({ confirmPass: event.target.value })
                        }
                        onBlur={this.validPassword}
                        required
                      />
                      <text
                        style={{
                          color: "red",
                          padding: "0.5rem",
                          display: "block",
                        }}
                      >
                        {this.state.samePass}
                      </text>
                      <span
                        className="focus-border"
                        style={{ top: "2.5rem" }}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row5 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="text"
                        placeholder="Birth place"
                        onChange={(event) =>
                          this.setState({ birth_place: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <p style={{ fontSize: "12px" }}>Tanggal Lahir</p>
                      <input
                        className="effect-1"
                        style={{ padding: "0.5rem", borderRadius: "10px" }}
                        type="date"
                        onChange={(event) =>
                          this.setState({ birth_date: event.target.value })
                        }
                        placeholder="Tanggal Lahir"
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row6 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="number"
                        placeholder="Home phone"
                        onChange={(event) =>
                          this.setState({ home_phone: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="number"
                        placeholder="Mobile phone"
                        onChange={(event) =>
                          this.setState({ mobile_phone: event.target.value })
                        }
                        required
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row7 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <select
                        className="effect-1"
                        style={{
                          padding: "0.5rem",
                          borderRadius: "10px",
                          backgroundColor: "#ffff",
                        }}
                        placeholder="Gender"
                        onChange={(event) =>
                          this.setState({ gender: event.target.value })
                        }
                        required
                      >
                        <option value="" disabled selected>
                          Gender
                        </option>
                        <option value={1}>Laki-laki</option>
                        <option value={2}>Perempuan</option>
                      </select>

                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <select
                        className="effect-1"
                        style={{
                          padding: "0.5rem",
                          borderRadius: "10px",
                          backgroundColor: "#ffff",
                        }}
                        placeholder="Pendidikan Terakhir"
                        onChange={(event) =>
                          this.setState({
                            educational_code: event.target.value,
                          })
                        }
                        required
                      >
                        <option value="" disabled selected>
                          Pendidikan Terakhir
                        </option>
                        {this.state.education.map((v, i) => (
                          <option value={v.educational_code} key={i}>
                            {v.educational_name}
                          </option>
                        ))}
                      </select>
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {/* row8 */}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <Select
                        placeholder="Ketik Kode Pos"
                        className="React"
                        classNamePrefix="Kode Pos"
                        style={{
                          padding: "0.5rem",
                          borderRadius: "10px",
                          border: "none",
                        }}
                        name="Kode Pos"
                        options={this.state.zipcode}
                        onInputChange={this.handleInputChange}
                        onChange={(e) => this.handleSelectChange(e)}
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="text"
                        placeholder="Province"
                        value={this.state.province}
                        onChange={(event) =>
                          this.setState({ province: event.target.value })
                        }
                        required
                        disabled
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col
                      md={{ span: 10, offset: 7 }}
                      sm={{ span: 10, offset: 7 }}
                      xs={{ span: 20, offset: 2 }}
                    >
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          marginBottom: "0.5rem",
                          borderRadius: "10px",
                        }}
                        type="text"
                        placeholder="City"
                        value={this.state.city}
                        onChange={(event) =>
                          this.setState({ city: event.target.value })
                        }
                        required
                        disabled
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col
                      md={{ span: 10, offset: 7 }}
                      sm={{ span: 10, offset: 7 }}
                      xs={{ span: 20, offset: 2 }}
                    >
                      {this.required() ? (
                        <button
                          type="submit"
                          value="Simpan"
                          className="active"
                          onClick={() => this.submit()}
                        >
                          Simpan
                        </button>
                      ) : (
                        <Popover
                          placement="top"
                          content={this.content(
                            "lightsalmon",
                            "Not allowed - Form data cannot be null"
                          )}
                        >
                          <button
                            type="submit"
                            value="Simpan"
                            className="inactive"
                            style={{ cursor: "not-allowed" }}
                            onClick={() => {}}
                          >
                            Simpan
                          </button>
                        </Popover>
                      )}
                    </Col>
                  </Col>
                </Row>
              </Col>
            </section>
          )}

          {formInst && (
            <section>
              <Col
                md={{ span: 14, offset: 5 }}
                sm={{ span: 18, offset: 3 }}
                xs={{ span: 20, offset: 2 }}
                className="card-inner-register"
              >
                {formInst.identity_number && (
                  <Row>
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="number"
                          placeholder="No KTP, NIK, No Passport"
                          onChange={(event) =>
                            this.setState({
                              identity_number: event.target.value,
                            })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <select
                          className="effect-1"
                          style={{
                            padding: "0.5rem",
                            borderRadius: "8px",
                            backgroundColor: "#ffff",
                          }}
                          placeholder="identity_code"
                          onChange={(event) =>
                            this.setState({ identity_code: event.target.value })
                          }
                          required
                        >
                          <option value="" disabled selected>
                            Jenis Identitas
                          </option>
                          <option value={1}>KTP</option>
                        </select>
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  </Row>
                )}
                <Row>
                  {formInst.fullname && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="text"
                          placeholder="Fullname"
                          onChange={(event) =>
                            this.setState({ fullname: event.target.value })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                  {formInst.nickname && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="text"
                          placeholder="Nickname"
                          onChange={(event) =>
                            this.setState({ nickname: event.target.value })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                </Row>
                <Row>
                  {formInst.address && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <textarea
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          placeholder="Address"
                          onChange={(event) =>
                            this.setState({ address: event.target.value })
                          }
                          required
                        />
                        <span
                          className="focus-border"
                          style={{ bottom: "0.35rem" }}
                        />
                      </Col>
                    </Col>
                  )}
                  {formInst.university && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <textarea
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          placeholder="Asal Sekolah/Universitas"
                          onChange={(event) =>
                            this.setState({ university: event.target.value })
                          }
                          required
                        />
                        <span
                          className="focus-border"
                          style={{ bottom: "0.35rem" }}
                        />
                      </Col>
                    </Col>
                  )}
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="email"
                        placeholder="Email"
                        value={this.state.email}
                        onChange={(event) =>
                          this.setState({ email: event.target.value })
                        }
                        readOnly
                      />
                      <span className="focus-border" />
                    </Col>
                  </Col>
                </Row>
                {/* ini password sementara nyala dulu aja */}
                <Row>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto auto auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="password"
                        placeholder="Password"
                        onChange={(event) =>
                          this.setState({ password: event.target.value })
                        }
                        onBlur={this.handlePassword}
                        required
                      />
                      <text
                        style={{
                          color: "red",
                          padding: "0.5rem",
                          display: "block",
                        }}
                      >
                        {this.state.msg}
                      </text>
                      <span
                        className="focus-border"
                        style={{ top: "2.5rem" }}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={12}
                    sm={12}
                    xs={24}
                    style={{ margin: "0.5rem auto auto auto" }}
                  >
                    <Col span={20} offset={2}>
                      <input
                        className="effect-1"
                        style={{
                          padding: "0.5rem 0.7rem",
                          borderRadius: "10px",
                        }}
                        type="password"
                        placeholder="Confirmation password"
                        onChange={(event) =>
                          this.setState({ confirmPass: event.target.value })
                        }
                        onBlur={this.validPassword}
                        required
                      />
                      <text
                        style={{
                          color: "red",
                          padding: "0.5rem",
                          display: "block",
                        }}
                      >
                        {this.state.samePass}
                      </text>
                      <span
                        className="focus-border"
                        style={{ top: "2.5rem" }}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  {formInst.birth_place && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="text"
                          placeholder="Birth place"
                          onChange={(event) =>
                            this.setState({ birth_place: event.target.value })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                  {formInst.birth_date && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <p style={{ fontSize: "12px" }}>Tanggal Lahir</p>
                        <input
                          className="effect-1"
                          style={{ padding: "0.5rem", borderRadius: "10px" }}
                          type="date"
                          onChange={(event) =>
                            this.setState({ birth_date: event.target.value })
                          }
                          placeholder="Tanggal Lahir"
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                </Row>
                <Row>
                  {formInst.home_phone && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="number"
                          placeholder="Home phone"
                          onChange={(event) =>
                            this.setState({ home_phone: event.target.value })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                  {formInst.mobile_phone && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="number"
                          placeholder="Mobile phone"
                          onChange={(event) =>
                            this.setState({ mobile_phone: event.target.value })
                          }
                          required
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                </Row>
                <Row>
                  {formInst.gender_code && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <select
                          className="effect-1"
                          style={{
                            padding: "0.5rem",
                            borderRadius: "10px",
                            backgroundColor: "#ffff",
                          }}
                          placeholder="Gender"
                          onChange={(event) =>
                            this.setState({ gender: event.target.value })
                          }
                          required
                        >
                          <option value="" disabled selected>
                            Gender
                          </option>
                          <option value={1}>Laki-laki</option>
                          <option value={2}>Perempuan</option>
                        </select>

                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                  {formInst.educational_code && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <select
                          className="effect-1"
                          style={{
                            padding: "0.5rem",
                            borderRadius: "10px",
                            backgroundColor: "#ffff",
                          }}
                          placeholder="Pendidikan Terakhir"
                          onChange={(event) =>
                            this.setState({
                              educational_code: event.target.value,
                            })
                          }
                          required
                        >
                          <option value="" disabled selected>
                            Pendidikan Terakhir
                          </option>
                          {this.state.education.map((v, i) => (
                            <option value={v.educational_code} key={i}>
                              {v.educational_name}
                            </option>
                          ))}
                        </select>
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                </Row>
                <Row>
                  {formInst.id_pos && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <Select
                          placeholder="Ketik Kode Pos"
                          className="React"
                          classNamePrefix="Kode Pos"
                          style={{
                            padding: "0.5rem",
                            borderRadius: "10px",
                            border: "none",
                          }}
                          name="Kode Pos"
                          options={this.state.zipcode}
                          onInputChange={this.handleInputChange}
                          onChange={(e) => this.handleSelectChange(e)}
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                  {formInst.id_pos && (
                    <Col
                      md={12}
                      sm={12}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col span={20} offset={2}>
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            borderRadius: "10px",
                          }}
                          type="text"
                          placeholder="Province"
                          value={this.state.province}
                          onChange={(event) =>
                            this.setState({ province: event.target.value })
                          }
                          required
                          disabled
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  )}
                </Row>
                {formInst.id_pos && (
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ margin: "0.5rem auto 0.8rem auto" }}
                    >
                      <Col
                        md={{ span: 10, offset: 7 }}
                        sm={{ span: 10, offset: 7 }}
                        xs={{ span: 20, offset: 2 }}
                      >
                        <input
                          className="effect-1"
                          style={{
                            padding: "0.5rem 0.7rem",
                            marginBottom: "0.5rem",
                            borderRadius: "10px",
                          }}
                          type="text"
                          placeholder="City"
                          value={this.state.city}
                          onChange={(event) =>
                            this.setState({ city: event.target.value })
                          }
                          required
                          disabled
                        />
                        <span className="focus-border" />
                      </Col>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col
                    md={24}
                    sm={24}
                    xs={24}
                    style={{ margin: "0.5rem auto 0.8rem auto" }}
                  >
                    {!formInst && (
                      <Col
                        md={{ span: 10, offset: 7 }}
                        sm={{ span: 10, offset: 7 }}
                        xs={{ span: 20, offset: 2 }}
                      >
                        {this.required() ? (
                          <button
                            type="submit"
                            value="Simpan"
                            className="active"
                            onClick={() => this.submit()}
                          >
                            Simpan
                          </button>
                        ) : (
                          <Popover
                            placement="top"
                            content={this.content(
                              "lightsalmon",
                              "Not allowed - Form data cannot be null"
                            )}
                          >
                            <button
                              type="submit"
                              value="Simpan"
                              className="inactive"
                              style={{ cursor: "not-allowed" }}
                              onClick={() => {}}
                            >
                              Simpan
                            </button>
                          </Popover>
                        )}
                      </Col>
                    )}

                    {formInst && (
                      <Col
                        md={{ span: 10, offset: 7 }}
                        sm={{ span: 10, offset: 7 }}
                        xs={{ span: 20, offset: 2 }}
                      >
                        <button
                          type="submit"
                          value="Simpan"
                          className="active"
                          onClick={() => this.submit()}
                        >
                          Simpan
                        </button>
                      </Col>
                    )}
                  </Col>
                </Row>
              </Col>
            </section>
          )}
        </>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isRegister: state.auth.login.isRegister,
    email: state.auth.login.email,
  };
};

export default connect(mapStateToProps, {
  setToken,
})(Index);
